import { render, staticRenderFns } from "./DeveloperConsole.vue?vue&type=template&id=07b87c0e&scoped=true&"
import script from "./DeveloperConsole.vue?vue&type=script&lang=js&"
export * from "./DeveloperConsole.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperConsole.vue?vue&type=style&index=0&id=07b87c0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b87c0e",
  null
  
)

export default component.exports